const CUSTOMER_DRIVER_REVIEW_STORAGE_KEY = 'dashboard:customer-driver-reviews';

const getStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }

  return window.localStorage;
};

const readReviewMap = () => {
  const storage = getStorage();

  if (!storage) {
    return {};
  }

  try {
    const rawValue = storage.getItem(CUSTOMER_DRIVER_REVIEW_STORAGE_KEY);

    if (!rawValue) {
      return {};
    }

    const parsedValue = JSON.parse(rawValue);
    return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : {};
  } catch (_) {
    return {};
  }
};

const writeReviewMap = nextValue => {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  try {
    storage.setItem(CUSTOMER_DRIVER_REVIEW_STORAGE_KEY, JSON.stringify(nextValue));
  } catch (_) {
    return;
  }
};

export const getStoredCustomerDriverReview = shipmentId => {
  if (!shipmentId) {
    return null;
  }

  const normalizedShipmentId = String(shipmentId).trim();
  const reviewMap = readReviewMap();
  const review = reviewMap[normalizedShipmentId];

  return review && typeof review === 'object' ? review : null;
};

export const getStoredCustomerDriverReviews = () => {
  const reviewMap = readReviewMap();

  return Object.values(reviewMap).filter(review => review && typeof review === 'object');
};

export const saveStoredCustomerDriverReview = review => {
  if (!review || !review.shipmentId) {
    return null;
  }

  const normalizedShipmentId = String(review.shipmentId).trim();
  const nextReview = {
    shipmentId: normalizedShipmentId,
    shipmentFriendlyId: review.shipmentFriendlyId || null,
    driverAuth0Id: review.driverAuth0Id || null,
    driverName: typeof review.driverName === 'string' ? review.driverName.trim() : '',
    rating: Number(review.rating || 0),
    reviewText: typeof review.reviewText === 'string' ? review.reviewText.trim() : '',
    submittedAt: review.submittedAt || new Date().toISOString(),
  };

  const reviewMap = readReviewMap();
  reviewMap[normalizedShipmentId] = nextReview;
  writeReviewMap(reviewMap);
  return nextReview;
};